import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less'],
  templateUrl: './before-subscription-downgrade.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class BeforeSubscriptionDowngradeTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<BeforeSubscriptionDowngradeTemplateData>;
}

export type BeforeSubscriptionDowngradeTemplateData = {
  header: string;
  p1_html: string;
  p2_html: string;
  button_link: string;
  button_text: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const BeforeSubscriptionDowngradeTemplateMocks: BeforeSubscriptionDowngradeTemplateData[] = [
  {
    header: 'Plan change scheduled in 14 days',
    p1_html: 'On <b>Feb 4th</b>, your plan will be changed from <b>Optimize</b> to <b>Start</b>',
    p2_html: `This means you can use <b>up to 5 jobs</b> at a time, If you're got more than that please archive any extra ones before the change.`,
    button_text: 'Go to Recruitee',
    button_link: 'http://recruitee.com',
    footer: {
      text: 'Need help?',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
